import React from "react";
import { Field, Form, FormikProps } from "formik";
import { Button, LinearProgress, NoSsr, Grid } from "@material-ui/core";

import { IRole } from "../models/IRole";
import { Validators } from "../../util/validators";
import { StyledTextField, TextField } from "../../components/TextField";
import {
  AutocompleteSelect,
  StyledAutocomplete
} from "../../components/AutocompleteSelect";

export const EditRoleForm: React.FunctionComponent<FormikProps<IRole>> = ({
  submitForm,
  isSubmitting,
  values
}: FormikProps<IRole>) => {
  const { isLoading, policyList } = values;
  const { name } = Validators.editRole;

  return (
    <Form>
      <StyledTextField
        type="text"
        label="Name"
        name="name"
        multiline={false}
        component={TextField}
        disabled={isSubmitting || isLoading}
        value={values.name}
        validate={name}
      />
      <br />

      <StyledTextField
        type="text"
        label="Subscription"
        name="subscription.name"
        multiline={false}
        component={TextField}
        disabled={true}
      />

      <br />

      <NoSsr>
        <StyledAutocomplete>
          <Field
            name="appliedPolicies"
            options={policyList}
            component={AutocompleteSelect}
            isDisabled={isSubmitting || isLoading}
            labelField="name"
            identityKey="id"
            placeholder="Add Policies"
            sortableKey="order"
            isMulti={true}
            isClearable={true}
            clearValue={[]}
          />
        </StyledAutocomplete>
      </NoSsr>

      {(isSubmitting || isLoading) && <LinearProgress />}
      <br />
      <Grid
        container={true}
        item={true}
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        <Button
          variant="contained"
          color="primary"
          disabled={isSubmitting || isLoading}
          onClick={submitForm}
        >
          Save
        </Button>
      </Grid>
    </Form>
  );
};
